import { Box, Typography } from '@mui/material';
import { ApolloQueryResult, OperationVariables, useMutation } from '@parkchirp/api-client';
import React, { useCallback } from 'react';

import { REMOVE_TENANT_FROM_SUBSCRIPTION } from '../../mutations';
import { SetShowSnackbar } from '../../types';
import { EditorModal } from '../modals';

interface RemoveTenantModalProps {
	subscriptionId: string;
	email: string;
	handleClose: () => void;
	refetch: (variables?: Partial<OperationVariables>) => Promise<ApolloQueryResult<any>>;
	setShowSnackbar: SetShowSnackbar;
	tenantSubscriptionId?: string;
	theme?: any;
}

export const RemoveTenantModal = ({
	subscriptionId,
	handleClose,
	refetch,
	email,
	setShowSnackbar,
	tenantSubscriptionId,
	theme,
}: RemoveTenantModalProps) => {
	const [removeTenant, { loading: removeTenantLoading }] = useMutation(REMOVE_TENANT_FROM_SUBSCRIPTION);

	const handleSubmit = useCallback(async () => {
		try {
			const response = await removeTenant({
				variables: {
					email,
					subscriptionId,
					tenantSubscriptionId,
				},
				context: { apiVersion: 'v2' },
			});
			if (!response?.data?.removeTenantFromSubscription) {
				setShowSnackbar({
					message: 'Failed to remove tenant user',
					severity: 'error',
					autoHideDuration: 15000,
					onClose: () => setShowSnackbar(null),
				});
				return;
			}
			refetch();
			handleClose();
		} catch {
			setShowSnackbar({
				message: 'Failed to remove tenant user',
				severity: 'error',
				autoHideDuration: 15000,
				onClose: () => setShowSnackbar(null),
			});
		}
	}, [setShowSnackbar, removeTenant, refetch, email, subscriptionId, handleClose, tenantSubscriptionId]);

	return (
		<EditorModal
			handleClose={() => handleClose()}
			handleSave={handleSubmit}
			hasUnsavedChanges={false}
			headerText={` Remove tenant user: ${email} ?`}
			containerClassName='addTenantModal'
			loading={removeTenantLoading}
			headerBorder
			theme={theme}
		>
			<Box style={{ margin: '10px 0' }}>
				<Typography style={{ margin: '20px 0' }}>
					User will no longer be able to access this subscription through the tenant portal.
				</Typography>
			</Box>
		</EditorModal>
	);
};
